import { Breadcrumb, Button, Col, Input, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Details from "./HRPolicy/Details";
import AddEditPolicy from "./HRPolicy/AddEditPolicy";
import { getClientid, getUserInfo, getUserList, getUserRoleId } from "redux/selectors";
import { connect, useSelector } from "react-redux";
import { CALL_API } from "common/API";

const CompanyPolicy = ({ userRoleId, ClientId, userInfo }) => {
  const [showComponent, setShowComponent] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const userList = useSelector(getUserList);
  const filteredUser = userList?.find(item => item.userid === userInfo?.userid);
  console.log("filteredUser",filteredUser);
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredData = dataSource?.filter((item) => {
    const hasRoleId = item?.roleId;
    const hasLocation = item?.location;

    if (hasRoleId && hasLocation) {
      return item.roleId.includes(userRoleId) && item.location.includes(filteredUser?.baselocationid);
    } else if (hasRoleId) {
      return item.roleId.includes(userRoleId);
    } else if (hasLocation) {
      return item.location.includes(filteredUser?.baselocationid);
    }

    return true;
  });

  const filteredDataSource = filteredData?.filter((item) =>
    item.policyTitle.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const policyColumns = [
    {
      title: "Policy Name",
      dataIndex: "policyTitle",
      key: "policyName",
    },
    {
      title: "Type",
      dataIndex: "policyType",
      key: "policyType",
    },
    // {
    //   title: "Policy Effective Date",
    //   dataIndex: "policyEffectiveDate",
    //   key: "policyEffectiveDate",
    //   render: (date) => {
    //     const dateFormat = moment(date).format("DD MMM YYYY");
    //     return `${dateFormat}`;
    //   },
    // },
    // {
    //   title: "Last Updated",
    //   dataIndex: "lastUpdated",
    //   key: "lastUpdated",
    //   render: (_, record) => (
    //     <>
    //     <Icon name="edit"/>
    //     <Icon name="delete"/>
    //     </>
    //   ),
    // },
  ];

  const goBack = () => {
    setShowComponent(1);
  };

  const deletePolicy = (policyId) => {
    setDataSource((prev) => prev.filter((item) => item.policyId !== policyId));
  };

  const getPolicyData = async () => {
    setLoading(true);
    const response = await CALL_API(`hrpolicy/${ClientId}`, "get", {});
    setLoading(false);
    setDataSource(response || []);
  };

  useEffect(() => {
    getPolicyData();
  }, []);

  return (
    <>
      {showComponent === 1 && (
        <>
          <Row gutter={16} className="d-flex justify-content-between align-items-center">
            <Col md={6} className="">
              {/* <b>Filter by</b> */}
              <Input
                className="mb-2"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                suffix={<SearchOutlined />}
              />
            </Col>
            {/* <Col>
              <Button type="primary" className="mb-2" onClick={() => setShowComponent(3)}>
                Add Policy
              </Button>
            </Col> */}
          </Row>
          <br />
          <Table
            dataSource={filteredDataSource}
            columns={policyColumns}
            pagination={false}
            loading={loading}
            // Note: Second params needed
            onRow={(record, rowIndex) => {
              return {
                onClick: () => {
                  setSelectedRow(record);
                  setShowComponent(2);
                },
              };
            }}
          />
        </>
      )}

      {showComponent === 2 && (
        <Details
          pagetitle="Company Policy"
          selectedRow={selectedRow}
          ClientId={ClientId}
          userInfo={userInfo}
          goBack={goBack}
          getPolicyData={getPolicyData}
          deletePolicy={deletePolicy}
        />
      )}

      {showComponent === 3 && (
        <>
          <div style={{ marginBottom: 12 }}>
            <Breadcrumb>
              <Breadcrumb.Item
                onClick={goBack}
                style={{ cursor: "pointer", color: "#1677ff" }}
              >
                HR Policies
              </Breadcrumb.Item>
              <Breadcrumb.Item>Add Policy</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <AddEditPolicy
            ClientId={ClientId}
            userInfo={userInfo}
            goBack={goBack}
            getPolicyData={getPolicyData}
          />
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(CompanyPolicy);